<div id="titleWaveform" style="text-align: center; font-weight: bold; margin-bottom: 15px;">
  <img src="assets/icon/prev.png" style="position: relative; top: 10px; cursor: pointer" (click)="changeFile('prev')">
  {{dataPassService.musiques_mix[position].file}}
  <img src="assets/icon/next.png" style="position: relative; top: 10px; cursor: pointer" (click)="changeFile('next')">
</div>

<div #waveformZoomContainer id="waveform-visualiser-zoom-container"></div>
<div #waveformOverviewContainer id="waveform-visualiser-overview-container"></div>

<div id="controls">
  <audio #audioEl id="audioEl" controls=controls>
    <source src="{{serverEndpoint}}/audioForWave?folder={{dataPassService.musiques_mix[position].folder}}&filename={{CF.escapeSpecialsURL(replacePlusSymbol(dataPassService.musiques_mix[position].file))}}" type="audio/mpeg">
  </audio>
</div>

<div id="modifications">
  <div class="reglages">
    <div class="group_btn start">
      <div class="btn_part_one">
        <button mat-raised-button class="btn btn-primary" id="btn_input" (click)="setValueSegment('start')">
          Start<br/><span id="input">{{ regionStart | timeFormat }}</span>
        </button>
      </div>
      <div class="btn_part_two">
        <button mat-raised-button class="btn btn-primary" id="btn_input_moins" (click)="incrementValueSegment('start', '-')">
          <mat-icon svgIcon="remove"></mat-icon>
        </button>
        <button mat-raised-button class="btn btn2 btn-primary" id="btn_input_preview" (click)="previewValue('start')">
          <mat-icon svgIcon="play"></mat-icon>
        </button>
        <button mat-raised-button class="btn btn-primary" id="btn_input_plus" (click)="incrementValueSegment('start', '+')">
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      </div>
    </div>

    <div class="group_btn intro">
      <div class="btn_part_one">
        <button mat-raised-button class="btn btn-primary" id="btn_intro" (click)="setValueIntro()">
          Intro<br/><span id="intro">{{ pointIntro | timeFormat }}</span>
        </button>
      </div>
      <div class="btn_part_two">
        <button mat-raised-button class="btn btn-primary" id="btn_intro_moins" (click)="incrementValueIntro('-')">
          <mat-icon svgIcon="remove"></mat-icon>
        </button>
        <button mat-raised-button class="btn btn2 btn-primary" id="btn_intro_preview" (click)="previewValue('intro')">
          <mat-icon svgIcon="play"></mat-icon>
        </button>
        <button mat-raised-button class="btn btn-primary" id="btn_intro_plus" (click)="incrementValueIntro('+')">
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      </div>
    </div>

    <div class="group_btn mix">
      <div class="btn_part_one">
        <button mat-raised-button class="btn btn-primary" id="btn_output" (click)="setValueSegment('mix')">
          Stop<br/><span id="output">{{ regionMix | timeFormat }}</span>
        </button>
      </div>
      <div class="btn_part_two">
        <button mat-raised-button class="btn btn-primary" id="btn_output_moins" (click)="incrementValueSegment('mix', '-')">
          <mat-icon svgIcon="remove"></mat-icon>
        </button>
        <button mat-raised-button class="btn btn2 btn-primary" id="btn_output_preview" (click)="previewValue('mix')">
          <mat-icon svgIcon="play"></mat-icon>
        </button>
        <button mat-raised-button class="btn btn-primary" id="btn_output_plus" (click)="incrementValueSegment('mix', '+')">
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      </div>
    </div>

    <div class="group_btn fade2">
      <div class="btn_part_one">
        <div class="btn btn3 btn-primary" id="btn_fade">
          <br/>Fade
        </div>
      </div>
      <mat-button-toggle-group #group="matButtonToggleGroup" [value]="fade" (change)="onValFadeChange(group.value)">
        <div class="btn_part_two">
          <mat-button-toggle class="btn btn-primary" value="x">X</mat-button-toggle>
          <mat-button-toggle class="btn btn-primary" value="0">0</mat-button-toggle>
          <mat-button-toggle class="btn btn-primary" value="1">1</mat-button-toggle>
        </div>
        <div class="btn_part_two">
          <mat-button-toggle class="btn btn-primary" value="2">2</mat-button-toggle>
          <mat-button-toggle class="btn btn-primary" value="3">3</mat-button-toggle>
          <mat-button-toggle class="btn btn-primary" value="4">4</mat-button-toggle>
        </div>
      </mat-button-toggle-group>
      <!--<div class="btn_part_two">
        <button class="btn btn-primary" id="btn_fade_x">
          X
        </button>
        <button class="btn btn-primary" id="btn_fade_0">
          0
        </button>
        <button class="btn btn-primary" id="btn_fade_1">
          1
        </button>
      </div>
      <div class="btn_part_two">
        <button class="btn btn-primary fade-select" id="btn_fade_2">
          2
        </button>
        <button class="btn btn-primary" id="btn_fade_3">
          3
        </button>
        <button class="btn btn-primary" id="btn_fade_4">
          4
        </button>
      </div>-->
    </div>
  </div>
</div>
